import React from "react";
import { useHistory } from "react-router-dom";
import { Button, HStack } from "@chakra-ui/react";
import {
  isActiveSession,
  isCancellableSession,
  isCancelledSession,
  isCompletedSession,
  isFutureSession,
  isPastSession
} from "utils/session";
import { useModal } from "context/modal";
import { useCancelSession, useCompleteSession, useUpdateSession } from "repo/sessions";
import { Session } from "types";
import SessionForm from "./SessionForm";
import { useQueryClient, QueryClient, Mutation} from "@tanstack/react-query"

interface Props {
  session: Session;
}

const SessionActions: React.FC<Props> = ({ session }: Props) => {
  const history = useHistory();
  const { openModal, setTitle, setContent } = useModal()!;

  const canCancel = isCancellableSession(session);


  const openEditModal = () => {
    setTitle("Update Session");
    setContent(
      <SessionForm
        session={session}
        mutationFn={useUpdateSession}
        completed={!canCancel}
        isUpdate={true}
      />
    );
    openModal();
  };

  const completeSessionMutation = useCompleteSession();
  const cancelSessionMutation = useCancelSession();

  return (
    <HStack justifyContent="flex-end">
      <Button
        aria-label="Start Session"
        hidden={!isActiveSession(session) || isCancelledSession(session)}
        onClick={() => history.push(`/session/${session.id}/preview`)}
        size="xs"
        variant="blue"
      >
        Join
      </Button>
      <Button
        aria-label="Update Session"
        size="xs"
        variant="blue"
        onClick={openEditModal}
      >
        Edit
      </Button>
      <Button
        aria-label="Complete Session"
        hidden={
          !isPastSession(session) ||
          isCancelledSession(session) ||
          isCompletedSession(session)
        }
        onClick={() => completeSessionMutation.mutate(session)}
        size="xs"
        variant="blue"
      >
        Complete
      </Button>
      <Button
        aria-label="Cancel Session"
        hidden={!canCancel}
        onClick={() => cancelSessionMutation.mutate(session)}
        size="xs"
      >
        Cancel
      </Button>
    </HStack>
  );
};

export default SessionActions;
